export default __webpack_public_path__ + "static/1-71688dd375126014dbf3a6555dd8bdae.png";